/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type PayoutRecord,
    PayoutRecordFromJSON,
    PayoutRecordToJSON,
} from '../models/PayoutRecord';
import {
    type SettlementPeriodDto,
    SettlementPeriodDtoFromJSON,
    SettlementPeriodDtoToJSON,
} from '../models/SettlementPeriodDto';

export interface GetPayoutsRequest {
    locationId: number;
    settlementPeriodDto: Array<SettlementPeriodDto>;
}

/**
 * 
 */
export class PayoutControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getPayouts without sending the request
     */
    async getPayoutsRequestOpts(requestParameters: GetPayoutsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getPayouts().'
            );
        }

        if (requestParameters['settlementPeriodDto'] == null) {
            throw new runtime.RequiredError(
                'settlementPeriodDto',
                'Required parameter "settlementPeriodDto" was null or undefined when calling getPayouts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/locations/{locationId}/payouts`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['settlementPeriodDto']!.map(SettlementPeriodDtoToJSON),
        };
    }

    /**
     */
    async getPayoutsRaw(requestParameters: GetPayoutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PayoutRecord>>> {
        const requestOptions = await this.getPayoutsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PayoutRecordFromJSON));
    }

    /**
     */
    async getPayouts(requestParameters: GetPayoutsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PayoutRecord>> {
        const response = await this.getPayoutsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
